export const admin = {
  dashboard: {
    title: "Dashboard",
    welcomeBack: "Welcome back",
    setUpYourProfile: "Set up your profile",
    stats: {
      balance: "Balance",
      sales: "Sales",
      views: "Views",
      followers: "Followers",
    },
    callToAction: "What would you like to do today?",
    createContent: "Create new content",
    viewAnalytics: "View analytics",
    recentPurchases: "Recent purchases",
    viewAllPurchases: "View all purchases",
    setupSteps: {
      title: "Profile setup",
      completeYourProfile: "Complete your profile",
      connectSocial: "Connect social account",
      createYourFirstProduct: "Create your first product",
      getReadyToSell: "Get ready to sell"
    },
    v2: {
      hero: {
        morning: "Good morning",
        afternoon: "Hi",
        evening: "Good evening",
        liveBadge: "Live",
        loading: "Putting together your day…",
        summary: "You have {bookings} bookings today, expected revenue {revenue} HUF, and {messages} unread messages.",
        chips: {
          bookings: "bookings today",
          credits: "AI credits",
          expected: "expected"
        },
        actions: {
          newBooking: "New booking",
          newProduct: "New product",
          aiPost: "Write AI post"
        }
      },
      kpi: {
        labels: {
          revenue: "Revenue (30d)",
          bookings: "Bookings (week)",
          customers: "New customers",
          conversion: "Conversion"
        }
      },
      schedule: {
        title: "Today's schedule",
        subtitle: "Bookings, workshops and open slots at a glance",
        tabs: { today: "Today", tomorrow: "Tomorrow", week: "Week" },
        addSlot: "New slot",
        break: "Break",
        legend: {
          booking: "Booking",
          private: "Private",
          workshop: "Workshop",
          break: "Break"
        }
      },
      ai: {
        title: "AI assistant tasks",
        subtitle: "Suggestions you can ship with one click",
        pending: "pending",
        emptyState: "All caught up — nice work!",
        accept: "Accept",
        dismiss: "Dismiss",
        ago: ""
      },
      trend: {
        title: "Revenue & bookings",
        last30: "last 30 days",
        bookings: "bookings",
        tabs: { revenue: "Revenue", bookings: "Bookings" }
      },
      topProducts: {
        title: "Top products",
        subtitle: "Ranked by weekly sales",
        units: "sold"
      },
      leads: {
        title: "New customers",
        subtitle: "Where your fresh leads come from",
        live: "Live",
        ago: "ago",
        sources: {
          instagram: "Instagram",
          website: "Website",
          referral: "Referral",
          google: "Google"
        }
      },
      funnel: {
        title: "Booking funnel",
        subtitle: "From Instagram to confirmed booking",
        conversion: "conversion"
      },
      community: {
        newReview: "New review",
        newMessage: "New message",
        unreadInstagram: "unread DMs",
        hoursAgo: "h ago",
        minutesAgo: "min ago"
      },
      setup: {
        title: "Getting started",
        continue: "Continue"
      }
    }
  },
  locations: {
    types: {
      online: "Online",
      in_person: "In Person"
    }
  },
  navigation: {
    dashboard: "Dashboard",
    content: "Content",
    orders: "Orders",
    customers: "Customers",
    messages: "Messages",
    settings: "Settings",
    logout: "Logout",
    packages: "Packages",
    groupCalls: "Group Calls",
    workshops: "Workshops",
    finances: "Finances",
    reviews: "Reviews",
    aiBuilder: "AI Builder",
    interactiveData: "Interactive Data",
    pageSetup: "Page Setup",
  },
  workshops: {
    title: "Workshop Management",
    activeWorkshops: "Active workshops",
    completedWorkshops: "Completed workshops",
    noActiveWorkshops: "You have no active workshops.",
    noCompletedWorkshops: "You have no completed workshops.",
    createWorkshop: "Create new workshop",
    editWorkshop: "Edit workshop",
    deleteWorkshop: "Delete workshop",
    details: "Details",
    location: "Location",
    onlineEvent: "Online event",
    physicalEvent: "Physical event",
    online: "Online",
  },
  groupCalls: {
    title: "Your Video Calls",
    groupCalls: "Group video calls",
    privateCalls: "Private video calls",
    activeGroupCalls: "Your active group calls",
    expiredGroupCalls: "Your expired group calls",
    activePrivateCalls: "Your active private calls",
    expiredPrivateCalls: "Your expired private calls",
    noActiveGroupCalls: "You have no active group calls.",
    noExpiredGroupCalls: "You have no expired group calls.",
    noActivePrivateCalls: "You have no active private calls.",
    noExpiredPrivateCalls: "You have no expired private calls."
  },
  packages: {
    title: "Your Packages",
    newPackage: "Create new package",
    editPackage: "Edit package",
    search: "Search packages",
    table: {
      coverImage: "Cover Image",
      title: "Title",
      price: "Price",
      uploadDate: "Upload Date",
      salesCount: "Sales",
      status: "Status",
      actions: "Actions"
    }
  },
  orders: {
    title: "Orders",
    activeOrders: "Active video orders",
    completedOrders: "Completed and rejected video orders",
    noActiveOrders: "No active video orders.",
    noCompletedOrders: "No completed or rejected video orders.",
    details: "Order details",
    uploadVideo: "Upload video",
    acceptOrder: "Accept order",
    rejectOrder: "Reject order",
    completeOrder: "Complete order",
    customer: "Customer",
    price: "Price",
    status: "Status",
    deadline: "Deadline",
    type: "Type",
    description: "Description",
    actions: "Actions"
  },
  content: {
    title: "Your Content",
    newContent: "New content",
    editContent: "Edit your content",
    search: "Search"
  },
  settings: {
    title: "Your Settings",
    profile: {
      title: "Profile Settings",
      profileImage: "Profile Image",
      coverImage: "Cover Image",
      name: "Your Name",
      username: "Username",
      email: "Email",
      bio: "Short Bio",
      categories: "Categories",
      save: "Save",
      socialMedia: "Social media links"
    },
    billing: {
      title: "Billing",
      bankAccount: "Bank Account",
      taxId: "Tax ID",
      companyName: "Company Name",
      billingAddress: "Billing Address",
      save: "Save"
    },
    socialMedia: {
      title: "Social Media",
      instagram: "Instagram",
      tiktok: "TikTok",
      youtube: "YouTube",
      facebook: "Facebook",
      twitter: "Twitter",
      save: "Save"
    },
    buttons: {
      save: "Save Changes",
      saving: "Saving...",
      cancel: "Cancel"
    },
    toast: {
      success: {
        title: "Settings saved",
        description: "Your settings have been updated successfully."
      },
      error: {
        title: "Error",
        description: "Failed to save settings. Please try again."
      }
    }
  },
  messages: {
    title: "Your Questions"
  },
  customers: {
    title: "Your Customers",
    search: "Search customer",
    filter: "Filter",
    activeCustomers: "Active customers",
    noActiveCustomers: "No active customers.",
    previousCustomers: "Previous customers",
    noPreviousCustomers: "No previous customers.",
    table: {
      name: "Name",
      email: "Email",
      date: "Registration Date",
      purchases: "Purchases",
      amount: "Amount",
      actions: "Actions"
    },
    details: {
      title: "Customer Details",
      personalInfo: "Personal Info",
      name: "Name",
      email: "Email",
      phone: "Phone",
      registrationDate: "Registration Date",
      purchases: "Purchases",
      purchaseDate: "Purchase Date",
      product: "Product",
      price: "Price",
      status: "Status",
      total: "Total",
      close: "Close"
    }
  },
  finances: {
    title: "Your Finances and Balance",
    payoutsList: "Your Payouts",
    pendingOrders: "Pending Orders",
    payoutId: "Payout ID",
    date: "Date",
    amount: "Amount",
    status: "Status",
    reference: "Reference",
    orderId: "Order ID",
    customer: "Customer",
    orderType: "Order Type",
    orderAmount: "Amount",
    orderDate: "Date",
    includedOrders: "Orders included in payout",
    errors: {
      balanceError: "Error loading your balance",
      payoutsError: "Error loading your payouts",
      orderPaymentsError: "Error loading order payment data",
      statsError: "Error loading your statistics"
    },
    balance: {
      title: "Your Balance",
      description: "Current balance",
      pending: "Pending amount",
      pendingOrders: "pending orders",
      nextPayout: "Next payout",
      explanation: "How do we calculate your balance?"
    },
    stats: {
      totalRevenue: "Total Revenue",
      thisMonth: "This Month",
      lastMonth: "Last Month"
    },
    tokenPurchases: {
      title: "Token Purchases",
      description: "Overview of your token purchases",
      package: "Package",
      tokens: "tokens",
      date: "Date",
      amount: "Amount",
      status: "Status",
      statuses: {
        completed: "Completed",
        pending: "Pending",
        failed: "Failed"
      },
      noData: "No token purchases yet"
    }
  },
  pageSetup: {
    title: "Page Settings",
    preview: "Preview",
    sections: {
      title: "Pages",
      add: "Add new section",
      reorder: "Reorder sections"
    },
    theme: {
      title: "Themes",
      primaryColor: "Primary Color",
      mode: "Mode",
      light: "Light",
      dark: "Dark"
    },
    save: "Save"
  },
  reviews: {
    title: "Reviews",
    listTitle: "Reviews List",
    idColumn: "Review ID",
    userColumn: "User",
    typeColumn: "Type",
    ratingColumn: "Rating",
    dateColumn: "Date",
    actionsColumn: "Actions",
    detailsButton: "Details",
    detailsTitle: "Review Details",
    rating: "Rating",
    textReview: "Text Review",
    sending: "Sending...",
    replyWithEmoji: "Reply with emoji",
    reporting: "Reporting...",
    report: "Report"
  },
  interactiveData: {
    title: "Interactive Data"
  },
  aiBuilder: {
    title: "AI Assistant",
    inputPlaceholder: "Type your answer...",
    thinking: "Thinking...",
    send: "Send"
  },
  registration: {
    backToEditing: "Back to editing"
  },
  tokens: {
    balance: "Token balance",
    used: "Used",
    total: "Total",
    buyTokens: "Buy Tokens",
    buyMore: "Buy more tokens",
    perMonth: "/month",
    packages: {
      basic: {
        name: "Basic Package",
        tokens: "10,000 tokens",
        price: "€29.90"
      },
      professional: {
        name: "Professional Package",
        tokens: "50,000 tokens",
        price: "€119.90"
      },
      enterprise: {
        name: "Enterprise Package",
        tokens: "200,000 tokens",
        price: "€389.90"
      }
    },
    dialog: {
      title: "Buy Tokens",
      description: "Choose the package that suits you",
      selectPackage: "Select package",
      cancel: "Cancel",
      purchase: "Purchase"
    }
  }
};
